<template>
    <div>
        <!-- 交易 -->
        <Echart :options="options" id="bottomLeftChart" height="230px" width="460px"></Echart>
    </div>
</template>

<script>
import Echart from '../../common/echart'
export default {
    data() {
        return {
            options: {},
        };
    },
    components: {
        Echart,
    },
    props: {
        cdata: {
            type: Object,
            default: () => ({})
        },
    },
    watch: {
        cdata: {
            handler(newData) {
                this.options = {
                    title: {
                        text: "单位：万元",
                        textStyle: {
                            color: "rgba(255, 255, 255, 0.7)",
                            fontSize: '13',
                        }
                    },
                    tooltip: {
                        show: "true",
                        trigger: 'item',
                        backgroundColor: 'rgba(0,0,0,0.4)', // 背景
                        padding: [8, 10], //内边距
                        formatter: function (params) {
                            if (params.seriesName != "") {
                                return params.name + ' ：  ' + params.value;
                            }
                        },

                    },
                    grid: {
                        borderWidth: 0,
                        top: 30,
                        bottom: 20,
                        left: 30,
                        right: 76,
                        textStyle: {
                            color: "#fff"
                        },
                        containLabel: true //设置自适应画布大小状态为开，也可通过设置left左移实现相同效果。
                    },
                    xAxis: {
                        type: 'value',
                        max: 'dataMax',
                        alignTicks: true,
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.1)',
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontWeight: 'normal',
                                fontSize: '12',

                            },
                            formatter: function (value, index) {
                                value = value.toString()
                                if (value >= 100000000000) {
                                    return (value.substring(0, 5) / 10) + '亿'
                                } else if (value >= 10000000000) {
                                    return (value.substring(0, 4) / 10) + '亿'
                                } else if (value >= 1000000000) {
                                    return (value.substring(0, 3) / 10) + '亿'
                                } else if (value >= 100000000) {
                                    return (value.substring(0, 2) / 10) + '亿'
                                } else if (value >= 10000000) {
                                    return value.substring(0, 4) + '万'
                                } else if (value >= 1000000) {
                                    return value.substring(0, 3) + '万'
                                } else if (value >= 100000) {
                                    return value.substring(0, 2) + '万'
                                } else if (value >= 10000) {
                                    return (value.substring(0, 2) / 10) + '万'
                                } else if (value >= 1000) {
                                    return value
                                } else {
                                    return value
                                }
                            },
                        },
                    },
                    yAxis: {
                        type: 'category',
                        offset: 90,
                        axisTick: {
                            show: false
                        },

                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: 'rgba(49, 167, 255, 0.9607843137254902)',

                            }
                        },
                        axisLabel: {
                            inside: false,
                            interval: 0,//横轴信息全部显示
                            // margin: 50, //刻度标签与轴线之间的距离
                            textStyle: {
                                color: '#31A7FF',
                                fontWeight: 'normal',
                                fontSize: '16',
                                align: 'left'
                            },
                            // formatter:function(val){
                            //     return val.split("").join("\n")
                            // },
                        },
                        data: newData.category
                    },

                    series: [{
                        type: 'bar',

                        itemStyle: {
                            normal: {
                                show: true,
                                color: "rgba(90, 216, 166, 1)",
                                label: {
                                    show: true,
                                    position: 'right',
                                    fontSize: '13',
                                    color: 'white',

                                },
                                barBorderRadius: [0, 8, 8, 0],
                                borderWidth: 0,
                            },
                            emphasis: {
                                shadowBlur: 15,
                                shadowColor: 'rgba(105,123, 214, 0.7)'
                            }
                        },
                        zlevel: 2,
                        barWidth: '30%',
                        data: newData.rateData,
                    }]
                }
            },
            immediate: true,
            deep: true
        },
    },
}
</script>